<template>
    <div>
        <vue-slider class="d-inline" ref="slider" :lazy="true" v-model="internalMin" :show="show" v-bind:min="min" v-bind:max="max" v-bind:tooltip="'always'" v-bind:formatter="minformatter"></vue-slider>
        <vue-slider class="d-inline" ref="slider" :lazy="true" v-model="internalMax" :show="show" v-bind:min="min" v-bind:max="max" v-bind:tooltip="'always'" v-bind:formatter="maxformatter"></vue-slider>
    </div>
</template>
<script>

    import Vue from 'vue';
    import vueSlider from 'vue-slider-component';
    import {playerService} from '../player-service';
    import lengthToMinutes from '../filters/length-to-minutes';

    export default Vue.component(
        'duration-slider',
        {

            components: {
                vueSlider
            },

            data() {
                return {
                    internalMin: this.value[0],
                    internalMax: this.value[1],
                    max: 2000,
                    min: 0
                }
            },

            mounted: function () {

                let ctx = this;

                /**
                 * Get the max track length value.
                 */

                $.ajax({
                    method: 'GET',
                    url: `/api/tracks-max-length`,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    cache: false
                })
                    .done(function (length) {

                        ctx.max = parseInt(length);

                        playerService.$emit('filtering-max-duration-change', ctx.max);

                    });

            },

            watch: {

                // On any internal changes update our v-model
                internalMin: function( value ) {

                    this.$emit('input', [value, this.internalMax]);

                    if(this.internalMax < value){
                        this.internalMax = value
                    }

                },

                // On any internal changes update our v-model
                internalMax: function( value ) {

                    this.$emit('input', [this.internalMin, value]);

                    if(value < this.internalMin){
                        this.internalMin = value
                    }

                },

                value: function (value) {
                    this.internalMin = value[0];
                    this.internalMax = value[1];
                }
            },

            methods: {

                minformatter: function (unformattedinternalValue) {
                    return 'Min: ' + this.$options.filters.lengthToMinutes(unformattedinternalValue);
                },
                maxformatter: function (unformattedinternalValue) {
                    return 'Max: ' + this.$options.filters.lengthToMinutes(unformattedinternalValue);
                }

            },

            props: {

                show: {
                    required: false,
                    default: true
                },

                value: {}

            }

        });
</script>